import { Constantes } from "../constants/constantsGlobal";
import { iQuotaRequest } from "../models/interfaceQuotaConfiguration";
import { iResponse } from "../models/interfaceResponse";

export async function chatBotProjectQuotaConfig(params: iQuotaRequest): Promise<iResponse> {
  try {
    const response = await fetch(Constantes.URI_ChatBotProjectQuotaConfig, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(params),
    });

    if (!response.ok) {
      throw new Error("Error obteniendo la configuración de cuotas desde la API");
    }  
    const data: iResponse = await response.json();
    return data;
  } catch (error) {
    console.error("Error en fetchQuotaConfig:", error);
    throw error;
  }
}
